import type { AuthScheme } from 'api';

import { AuthenticationCard } from './AuthenticationCard';
import { AUTHENTICATION_GRID_TEST_ID } from './constants';

type AuthenticationGridProps = {
  keys: AuthScheme[];
};

export const AuthenticationGrid = ({ keys }: AuthenticationGridProps) => (
  <div
    data-testid={AUTHENTICATION_GRID_TEST_ID}
    className="flex w-full flex-wrap gap-6"
  >
    {keys.map((k) => (
      <AuthenticationCard key={k.uuid} authenticationKey={k} />
    ))}
  </div>
);
